const toggleClassList = ({ isAdd, element }) => {
    if (!element) return;

    if (isAdd) {
        !element.classList.contains('visible') && element.classList.add('visible');

        return;
    }

    element.classList.contains('visible') && element.classList.remove('visible');
}

export default toggleClassList;
